import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ShortTestimonials } from './components/ShortTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { TomosSlider } from './components/TomosSlider';
import { BonusSlider } from './components/BonusSlider';
import { PricingSection } from './components/PricingSection';
import { FutbolTacticoPro } from './components/FutbolTacticoPro';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalComparisonTable } from './components/FinalComparisonTable';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-dark overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ShortTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductOverview data-id="element-4" />
      <TomosSlider data-id="element-5" />
      <BonusSlider data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FutbolTacticoPro data-id="element-8" />
      <ExtendedTestimonials data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <FinalComparisonTable data-id="element-12" />
      <FinalCta data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}